import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { envIsNormal } from '@/constants/constants';
import { GTagEvents, triggerGTag } from '@/lib/gTagManager';
import BffApiService from '@/shared/bffApiService';
import { setOntarioCanPlay } from '@/store/actions/commonActions';
import { selectLocale, selectOntarioCanPlay } from '@/store/selectors/commonSelectors';
import { selectIsAuthenticated } from '@/store/selectors/authSelectors';
import { useBffRequest } from '@/hooks/useBffRequest';
import { useModal } from '@/features/modal/useModal';
import { MODALS } from '@/features/modal/types';

export function useOntarioCheck(): void {
  const dispatch = useDispatch();
  const { openModal } = useModal();
  const { request } = useBffRequest(BffApiService.ontarioCheck);
  const ontarioCanPlay = useSelector(selectOntarioCanPlay);
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const locale = useSelector(selectLocale);

  useEffect(() => {
    if (!envIsNormal() || !locale) {
      return;
    }

    request({
      successCallback: data => {
        triggerGTag(data ? GTagEvents.ontario_check_true : GTagEvents.ontario_check_false);
        dispatch(setOntarioCanPlay(!!data));
      },
    });
  }, [locale]);

  // if user logs in, it will log the user out if he is in ontario
  useEffect(() => {
    if (!envIsNormal()) {
      return;
    }

    if (isAuthenticated && !ontarioCanPlay) {
      openModal(MODALS.ONTARIO_CHECK);
    }
  }, [isAuthenticated, ontarioCanPlay]);
}
